/* Dunorm cart upsell - swap a cart line to the variant that includes the chosen add-on.
   Shopify has no "change the variant of a line" endpoint, so this removes the line and
   adds the upgraded variant at the same quantity.

   Listener is DELEGATED on document because the cart drawer section is re-rendered after
   every cart change - a listener bound to the button itself would die on the first render. */
(function () {
  if (window.__dnCartUpsell) return;
  window.__dnCartUpsell = true;

  var busy = false;

  async function refreshCartUI() {
    var res = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
    if (!res.ok) return;
    var data = await res.json();
    var parser = new DOMParser();

    if (data['cart-drawer']) {
      var incoming = parser.parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
      var current = document.querySelector('cart-drawer');
      if (incoming && current) {
        current.innerHTML = incoming.innerHTML;
        // Dawn toggles is-empty on the element itself, not inside it.
        current.classList.toggle('is-empty', incoming.classList.contains('is-empty'));
      }
    }
    if (data['cart-icon-bubble']) {
      var bubbleNew = parser.parseFromString(data['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleNew && bubble) bubble.innerHTML = bubbleNew.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('dn:cart:updated'));
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-dn-upsell]');
    if (!btn || busy) return;
    e.preventDefault();

    var key = btn.getAttribute('data-key');
    var variantId = btn.getAttribute('data-variant');
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!key || !variantId) return;

    busy = true;
    btn.classList.add('is-busy');
    btn.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      // Add the upgraded variant FIRST, so a failure here leaves the original line intact
      // rather than emptying the customer's cart.
      var add = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
      });
      if (!add.ok) throw new Error('add failed');

      // Then drop the original line, addressed by its line item KEY.
      // Do NOT use a line index here: cart/add.js puts the new item at line 1, so an
      // index captured before the add would delete the upgrade instead of the original.
      var remove = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      if (!remove.ok) throw new Error('remove failed');

      await refreshCartUI();
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('is-busy');
      console.error('[dn-cart-upsell]', err);
    } finally {
      busy = false;
    }
  });
})();
